module.exports = __webpack_public_path__ + "img/bsignup-continue-2.bd2401e5.png";